(() => {
  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  ready(() => {
    document.documentElement.classList.add('ps-enhanced');

    var psFitmentTagFallback = new URLSearchParams(window.location.search);
    var pendingModel = psFitmentTagFallback.get('ps_model');
    if (pendingModel && window.location.pathname.indexOf('/collections/all/') === 0) {
      var pendingTag = 'model_' + pendingModel.toLowerCase().replace(/\s+/g, '');
      if (window.location.pathname.toLowerCase().indexOf(pendingTag) === -1) {
        var pendingSearch = '/search?q=' + encodeURIComponent(pendingModel)
          + '&type=product&options%5Bprefix%5D=last'
          + '&ps_brand=' + encodeURIComponent(psFitmentTagFallback.get('ps_brand') || '')
          + '&ps_model=' + encodeURIComponent(pendingModel)
          + '&ps_component=' + encodeURIComponent(psFitmentTagFallback.get('ps_component') || '');
        window.location.replace(pendingSearch);
        return;
      }
    }

    const header = document.querySelector('.ps-header-fixed');
    if (header) {
      const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
      updateHeader();
      window.addEventListener('scroll', updateHeader, { passive: true });
    }

    document.querySelectorAll('form[data-ps-quote-form], .ps-h2f-contact-form').forEach((form) => {
      const submit = form.querySelector('button[type="submit"]');
      if (!submit) return;
      const idleLabel = submit.textContent.trim();
      form.addEventListener('submit', () => {
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
        submit.textContent = 'Sending request...';
        window.setTimeout(() => {
          submit.disabled = false;
          submit.removeAttribute('aria-busy');
          submit.textContent = idleLabel;
        }, 10000);
      });
    });

    document.querySelectorAll('form[action*="/cart/add"] button[type="submit"]').forEach((button) => {
      const form = button.closest('form');
      if (!form) return;
      form.addEventListener('submit', () => {
        button.setAttribute('aria-busy', 'true');
        button.classList.add('is-loading');
        window.setTimeout(() => {
          button.removeAttribute('aria-busy');
          button.classList.remove('is-loading');
        }, 8000);
      });
    });

    document.querySelectorAll('a[href^="#"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const id = link.getAttribute('href');
        if (!id || id === '#') return;
        const target = document.querySelector(id);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      });
    });

    const fitmentForm = document.querySelector('.ps-fitment-card form, form[data-ps-fitment-form]');
    if (fitmentForm && !fitmentForm.querySelector('[data-ps-fitment-status]')) {
      const status = document.createElement('p');
      status.setAttribute('data-ps-fitment-status', '');
      status.setAttribute('role', 'status');
      status.style.margin = '14px 0 0';
      status.style.color = '#52320C';
      status.style.fontSize = '13px';
      fitmentForm.appendChild(status);
      fitmentForm.addEventListener('submit', () => {
        status.textContent = 'Checking compatible listings...';
      });
    }
  });
})();

// Fitment finder — model options per brand
  var psModelData = {
    'komatsu': ['PC60-7','PC70-8','PC78US-6','PC78UU-6','PC110-7','PC128US-1','PC128UU-1','PC130-7','PC130-8','PC138US-8','PC200-5','PC200-6','PC200-7','PC200-8','PC200-8MO','PC210-10','PC210-7','PC210-8','PC220-5','PC220-6','PC220-7','PC220-8','PC240-7','PC240-8','PC240LC-10','PC270-7','PC270-8','PC290-10','PC290-11','PC290-8','PC290-9','PC300-10','PC300-11','PC300-5','PC300-6','PC300-7','PC300-8','PC300-9','PC360-10','PC360-11','PC360-7','PC360-8','PC360-9','PC400-6','PC400-7','PC400-8','PC-7','PC-8','PC650LC-11','PC800LC-8','PC950-11R','PC1250-7','PC1250-8','PC1250-11R','PC1250LC-11','PC2000-8','PC2000-11R','PC3000-6','PC3000-11','PC3400-11M0','PC4000-6','PC4000-11'],
    'caterpillar': ['300','300B','305.5','305CR','306','306CR','306E','307E','308CR','315','315D','316','320','320C','320D','320D2','320DL','320F','320GC','323','323D','323D2','325','325C','325D','326','329D','330','330C','330D','330D2','330F','336C','336D','345B','345C','345D','349E','349F','E200B','E240B','E300','E320C','E320D','E330C','E330D','E336D','E340D','E450','E650','EL300','MS300-8','365B','365C','374D','374F','374','385B','385C','390D','390F','395','6015','6015B','6020','6020B','6030','6040'],
    'hitachi': ['EX100-2','EX100-3','EX100-5','EX120-2','EX120-3','EX120-5','EX135UR-5','EX135US-5','EX200-5','EX200-6','EX300-5','EX350-5','ZAX200','ZAX200-3','ZAX210-3','ZAX240-3','ZAX330','ZAX330-3','ZAX360','ZX170LC-5A','ZX200-1','ZX200-3','ZX200-5A','ZX200-5G','ZX200LC-3','ZX210-3','ZX210-5G','ZX210LC-5','ZX210LC-6','ZX230-1','ZX230-3','ZX240','ZX240-3','ZX240-5A','ZX250','ZX250-3','ZX250-5G','ZX270-1','ZX270-3','ZX290','ZX330','ZX330-1','ZX330-3','ZX330-6','ZX350-3G','ZX350LC-5','ZX350LC-6','ZX360','ZX360-3','ZX360-6','ZX400LCH-5A','ZX490','ZX490LCH-5A','ZX490LCH-6','ZX-3','ZX670LCH-5G','ZX690LCH-7','ZX870LCH-5G','ZX890LCH-7','EX1200-5','EX1200-6','EX1200-7','EX1900-5','EX1900-6','EX2500-5','EX2600-6','EX2600-7','EX3500-5','EX3600-6','EX3600-7'],
    'volvo': ['EC140B','EC140C','EC140D','EC140E','EC160B','EC160C','EC160E','EC180B','EC180C','EC210','EC210B','EC210C','EC220','EC220D','EC220E','EC240','EC240B','EC250D','EC250E','EC290B','EC300D','EC650','EC650B','EC700B','EC700C','EC750E','EC950F'],
    'sany': ['SY215','SY215-9','SY215C','SY650H','SY650HB','SY750H','SY870H','SY980H','SY1050H','SY1250H','SY2000H','SY3000E','SY4000H'],
    'xcmg': ['XE600GK','XE700GK','XE900D','XE1250G','XE1350','XE2000','XE3000','XE4000','XE4000E'],
    'john-deere': ['210G','210GLC','245GLC','250G','300G','350G','470GLC'],
    'bobcat': ['E15','E17','E26'],
    'kubota': ['151','KX151'],
    'kawasaki': ['K3V112DT','K5V200DP','M2X146','M2X150','M2X170','M5X130']
  };
  var brandSel = document.getElementById('ps-brand');
  var modelSel = document.getElementById('ps-model');
  if (brandSel && modelSel) {
    brandSel.addEventListener('change', function() {
      modelSel.innerHTML = '<option value="">Select model</option>';
      var models = psModelData[this.value] || [];
      models.forEach(function(m) {
        var o = document.createElement('option');
        o.value = m; o.textContent = m;
        modelSel.appendChild(o);
      });
    });
  }
  function psFitmentSearch(e) {
    e.preventDefault();
    var brand = document.getElementById('ps-brand').value;
    var model = document.getElementById('ps-model').value;
    var comp  = document.getElementById('ps-component').value;
    var oem   = document.getElementById('ps-oem').value.trim();

    // OEM 优先:标签过滤即时生效(搜索索引有延迟),命中则走标签页,否则回退全文搜索
    if (oem) {
      var compact = oem.replace(/[\s-]/g, '').toLowerCase();
      var raw = oem.toLowerCase();
      fetch('/collections/all/' + encodeURIComponent(compact) + '?view=data')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var hit = html && html.indexOf('/products/') > -1;
          window.location.href = hit
            ? '/collections/all/' + encodeURIComponent(compact)
            : '/search?q=' + encodeURIComponent(oem) + '&type=product';
        })
        .catch(function () {
          window.location.href = '/search?q=' + encodeURIComponent(oem) + '&type=product';
        });
      return false;
    }

    if (model) {
      var modelTag = 'model_' + model.toLowerCase().replace(/\s+/g, '');
      var candidateTags = [modelTag];
      if (comp) candidateTags.push('part_' + comp);
      var candidateParams = new URLSearchParams({
        ps_brand: brand,
        ps_model: model,
        ps_component: comp
      });
      window.location.href = '/collections/all/' + candidateTags.join('+') + '?' + candidateParams.toString();
      return false;
    }

    var tags = [];
    if (brand) tags.push('brand_' + brand);
    if (comp) tags.push('part_' + comp);
    if (!tags.length) { var status = document.querySelector('[data-ps-fitment-status]'); if (status) status.textContent = 'Choose at least one machine or component field, or enter an OEM number.'; return false; }

    // Shopify collection tags provide a fast broad filter when no model is selected.
    window.location.href = '/collections/all/' + tags.join('+');
    return false;
  }

  var psFitmentForm = document.querySelector('[data-ps-fitment-form]');
  if (psFitmentForm) psFitmentForm.addEventListener('submit', psFitmentSearch);

  var psSearchContact = document.querySelector('[data-ps-search-contact]');
  if (psSearchContact) {
    var searchParams = new URLSearchParams(window.location.search);
    var contactUrl = new URL(psSearchContact.href, window.location.origin);
    ['ps_brand', 'ps_model', 'ps_component'].forEach(function(key) {
      var value = searchParams.get(key);
      if (value) contactUrl.searchParams.set(key, value);
    });
    psSearchContact.href = contactUrl.toString();
  }

  var psTechnicalForm = document.getElementById('PowerSoonTechnicalRequest');
  if (psTechnicalForm) {
    var contactParams = new URLSearchParams(window.location.search);
    var requestType = psTechnicalForm.querySelector('[name="contact[Request type]"]');
    var machineBrand = psTechnicalForm.querySelector('[name="contact[Machine brand]"]');
    var machineModel = psTechnicalForm.querySelector('[name="contact[Model]"]');
    var details = psTechnicalForm.querySelector('[name="contact[body]"]');
    var paramBrand = contactParams.get('ps_brand');
    var paramModel = contactParams.get('ps_model');
    var paramComponent = contactParams.get('ps_component');

    if (contactParams.get('type') === 'seal-kit' && requestType) requestType.value = 'Excavator seal kit';
    if (paramBrand && machineBrand) {
      Array.from(machineBrand.options).some(function(option) {
        if (option.text.toLowerCase() === paramBrand.toLowerCase()) {
          machineBrand.value = option.value;
          return true;
        }
        return false;
      });
    }
    if (paramModel && machineModel) machineModel.value = paramModel;
    if (details && (paramBrand || paramModel || paramComponent)) {
      details.value = 'Fitment request: ' + [paramBrand, paramModel, paramComponent ? paramComponent.replace(/-/g, ' ') : ''].filter(Boolean).join(' | ');
    }
  }

  // Mobile menu toggle
  var psHamburger = document.getElementById('ps-hamburger');
  var psMobileMenu = document.getElementById('ps-mobile-menu');
  var psMobileClose = document.getElementById('ps-mobile-close');
  if (psHamburger && psMobileMenu) {
    psHamburger.addEventListener('click', function() {
      psMobileMenu.classList.add('open');
      psHamburger.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  }
  if (psMobileClose && psMobileMenu) {
    psMobileClose.addEventListener('click', function() {
      psMobileMenu.classList.remove('open');
      if (psHamburger) psHamburger.classList.remove('active');
      document.body.style.overflow = '';
    });
  }
  // Close mobile menu when clicking any link inside it
  if (psMobileMenu) {
    psMobileMenu.querySelectorAll('a').forEach(function(a) {
      a.addEventListener('click', function() {
        psMobileMenu.classList.remove('open');
        if (psHamburger) psHamburger.classList.remove('active');
        document.body.style.overflow = '';
      });
    });
  }

(function () {
      function syncPsHeaderOffset() {
        var fixedHeader = document.getElementById('ps-header-fixed');
        var main = document.getElementById('MainContent');
        if (!fixedHeader || !main) return;
        main.style.paddingTop = fixedHeader.offsetHeight + 'px';
      }
      syncPsHeaderOffset();
      window.addEventListener('load', syncPsHeaderOffset);
      window.addEventListener('resize', syncPsHeaderOffset);
    })();
